import * as yup from 'yup';
import t from 'react-translate';

export type ContactLearnersFormValues = {
  subject: string;
  // MUST be a string at all times — Froala crashes if model is undefined/object.
  body: string;
  includePushNotification: boolean;
  pushNotificationBody: string;
};

export type DefaultMessageVariant = {
  subject: string;
  body: string;
  pushMessage: string;
};

export const buildDefaultValues = (variant: DefaultMessageVariant): ContactLearnersFormValues => ({
  subject: variant.subject,
  body: variant.body,
  includePushNotification: true,
  pushNotificationBody: variant.pushMessage,
});

export const buildValidationSchema = () => yup.object().shape({
  subject: yup.string()
    .required(t.VALIDATION.REQUIRED())
    .min(1, t.VALIDATION.MIN('1'))
    .max(255, t.VALIDATION.MAX('255')),
  body: yup.string()
    .required(t.VALIDATION.REQUIRED()),
  includePushNotification: yup.boolean(),
  pushNotificationBody: yup.string().nullable()
    .when('includePushNotification', {
      is: true,
      then: yup.string()
        .required(t.VALIDATION.REQUIRED())
        .min(1, t.VALIDATION.MIN('1'))
        .max(255, t.VALIDATION.MAX('255')),
    }),
});
